import { get } from 'lodash';
import React from 'react';
import { OriSelect } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import TextAndEditIcon from 'src/components/DragRowDisplay/TextAndEditIcon';
import WarningIcon from 'src/components/Icon/Warning';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import ImageAndPosterEditModalBody from 'src/components/Modules-revamp/ImageAndPoster';
import { Field } from 'src/components/RcForm';
import ModalHoc from 'src/constrains/ModalHOC';
import {
  checkResponsivePosterTab,
  validatePosterCarouselSetting,
} from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import { useI18n } from 'src/hooks/useRouterChange';
import { sectionProps } from 'src/tools/constant';
import { posterType, posters, tabs } from 'src/tools/contentModulesFieldName';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';
const Option = OriSelect.Option;

const PosterTabEdit = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    disabled,
    options,
    index,
    tabDraggableId,
    onSort,
    onTypeChange,
    modalOp,
    onModalConfirm,
    breakpoint,
    animationOptions,
    hoverEffectOptions,
    buttons,
    modalFunc,
  } = props;
  const { setShowModal, setModalTitle, setModalContent } = modalOp;
  const prefixName = [tabs, index];
  const { checkEachPosterError } = checkResponsivePosterTab();
  const { checkImage, checkImageLink, checkName } =
    validatePosterCarouselSetting();
  return (
    <Field name={[...prefixName, posters]}>
      {(p, m) => {
        const { value, onChange } = p;
        const handleOnSort = (obj) => {
          const { data } = obj;
          const { newIndex, oldIndex } = data || {};
          onSort(value, onChange, oldIndex, newIndex);
        };

        const handleOnConfirm = (data, index) => {
          onModalConfirm(value, onChange, data, index);
          setShowModal(false);
        };

        const handleOnChildGenerate = (data, index) => {
          const error = checkEachPosterError(data, { breakpoint });
          const hasError = get(error, 'hasError');
          // console.log('data1', data);
          const { name } = data;

          return (
            <TextAndEditIcon
              disabled={disabled}
              containerClassName={css.itemContainer}
              additional={
                hasError ? (
                  <div className={css.errorIconContainer}>
                    <WarningIcon />
                  </div>
                ) : null
              }
              name={name}
              onClick={() => {
                setModalTitle(
                  getI18n('salesChannelContent.index.posterSetting'),
                );
                setModalContent(
                  <ImageAndPosterEditModalBody
                    validators={{
                      name: checkName,
                      image: checkImage,
                      link: checkImageLink,
                    }}
                    data={data}
                    breakpoint={breakpoint}
                    animationOptions={animationOptions}
                    hoverEffectOptions={hoverEffectOptions}
                    buttons={buttons}
                    modalRenderer={modalFunc}
                    onConfirm={(v) => {
                      handleOnConfirm(
                        {
                          ...(data || {}),
                          ...v,
                        },
                        index,
                      );
                    }}
                    onCancel={() => {
                      setShowModal(false);
                    }}
                  />,
                );
                setShowModal(true);
              }}
            />
          );
        };

        return (
          <React.Fragment>
            <Section {...sectionProps} id={tabDraggableId}>
              <ItemWrapper title={getI18n('general.posterType')}>
                <Field name={[...prefixName, posterType]}>
                  {(props, m) => {
                    const { value: _v, onChange: _onChange } = props;
                    return (
                      <OriSelect
                        {...m}
                        disabled={disabled}
                        size='large'
                        onChange={(e) => {
                          _onChange(e);
                          onTypeChange(value, onChange, e);
                        }}
                        value={_v}>
                        {options.map((i) => {
                          const { label, value } = i;
                          return (
                            <Option value={value} key={value}>
                              {label}
                            </Option>
                          );
                        })}
                      </OriSelect>
                    );
                  }}
                </Field>
              </ItemWrapper>
            </Section>
            <DragNDropColumns
              disabled={disabled}
              // hideAdd={!isPrimary}
              hideTitle
              childGenerate={handleOnChildGenerate}
              data={value || []}
              droppableId={`salesChannelContentListResponsiveImageCarousel${tabDraggableId}`}
              onSort={handleOnSort}
              hideAdd
            />
          </React.Fragment>
        );
      }}
    </Field>
  );
};
export default ModalHoc(PosterTabEdit, { width: 1180 });
